import { clone } from '../object/clone';
import { tokenizer } from './tokenizer';

/**
 * Devuelve el `scope` despùes de haber borrado el campo `model`.
 * OJO que si se usa no immutable, se modificara el scope original.
 *
 * @param {Object} scope el scope base
 * @param {string} model el modelo del campo a borrar
 * @param {Object} [options] Opciones
 * @param {Object} [options.isImmutable=true] Por defecto se va devolver un clone del scope
 * @returns {Object} el scope modificado (un clone si isImmutable)
 */
export function deleteFromScope(scope, model, options = {}) {
  const { isImmutable = true } = options;
  const localScope = isImmutable ? clone(scope) : scope;

  // troceamos el modelo, ej: "foo.bar[1].text" => foo, bar, 1, text
  const splitted = tokenizer(model);
  const last = splitted.length - 1;

  // Recorremos el scope en busca del ultimo
  splitted.reduce((acc, cur, i) => {
    if (typeof acc === 'undefined') {
      // si algun paso intermediario ya es undefined, no hace falta seguir, el modelo buscado ya sabemos que no existe
      return;
    }

    // Si es el ultimo campo,
    const isLast = i === last;
    if (isLast && typeof acc[cur] !== 'undefined') {
      delete acc[cur]; // borramos
    }

    return acc[cur];
  }, localScope);

  return localScope;
}
